define('views/pages/NewsPageView',['underscore', 'jquery', 'PageView', 'router', 'app',
    'template!list-news',
    'template!single-news',
    'template!blocks/news/flags-top',
    'template!blocks/news/nav',
    'template!blocks/news/single',
    'template!blocks/news/list',
], function (_, $, PageView, router, app,
             templateList,
             templateSingle,
             flagsTopTemplate,
             navTemplate,
             singleTemplate,
             listTemplate
             ) {

    var hash;
    var ITEMS_PER_PAGE = 8;
    var pageIndex = 0;
    var $newsItems;
    var pageIndex = 1;
    var pageIndexMax = 1;
    var currentFilter;

    function preventDefault(e){
        e.preventDefault();
        e.stopPropagation();
    }

    function getCurrentFlag(link_rewrite){
        var newsFlags = app.get('newsFlag'),
            currentFlag;
        currentFlag = newsFlags.findWhere({url_rewrite:link_rewrite}) || newsFlags.getAllNewsFlag();
        return currentFlag;
    }
    function getCurrentNews(link_rewrite){
        var news = app.get('news'),
            currentNews;
        currentNews = news.findWhere({link_rewrite:link_rewrite});
        return currentNews;
    }

    return PageView.extend({
        pageName: 'News',
        activeSlide: 0,
        events: {
            'click .news-filter': 'filterNav',
            'click .news-list-pagination span:not(.arrow)': 'goToPage',
            'click .news-list-pagination .prev': 'prevPage',
            'click .news-list-pagination .next': 'nextPage',
            'click .news-list-pagination .index': 'listIndexPage',
        },

        initialize:function(options){

            ITEMS_PER_PAGE = parseInt(app.c('_NEWS_PAGINATION_',ITEMS_PER_PAGE));

            var view = this, subpage, mainEl, currentFlag, link_rewrite;
            PageView.prototype.initialize.apply(view,arguments);
            view.subviews = [];
            $('#home-preloader').remove();

            if (options.el) {
                // classic page loading initialize
                mainEl = view.$('.news-main');
                subpage = mainEl.data('subpage');
                link_rewrite = mainEl.data('link_rewrite');
                if(subpage === 'list'){
                    currentFlag = getCurrentFlag(link_rewrite);
                }else{
                    var singleNews = view.singleNews = getCurrentNews(link_rewrite);
                    currentFlag = singleNews.getDefaultFlag() || getCurrentFlag('*');
                    options.flag_link_rewrite = currentFlag.get('url_rewrite');
                    options.news_link_rewrite = singleNews.get('link_rewrite');
                }

                options.subpage =
                view.subpage = subpage;
                view.currentFlag = currentFlag;
                view.render();
            } else {
                // microtemplating initialize
                view.microtemplate(options);
            }

        },

        microtemplate:function(options){
            var view = this, subpage = options.subpage, currentFlag, singleNews;
            view.pageOptions = _.defaults(options,{});;

            singleNews = getCurrentNews(options.news_link_rewrite);
            if(singleNews){
                currentFlag = singleNews.getDefaultFlag() || getCurrentFlag('*');
                options.flag_link_rewrite = currentFlag.get('url_rewrite');
                view.singleNews = singleNews;
            }else{
                currentFlag = getCurrentFlag(options.flag_link_rewrite);
            }
            view.currentFlag = currentFlag;

            // reset pageIndex to 1
            pageIndex = 1;

            if(!view.subpage || (subpage!==view.subpage)){
                // on arrive sur une nouvelle page
                // ou
                // on change de typologie
                view.subpage = subpage;
                view.render();
                app.scrollTop(0,500);
            }else{
                // on ne change pas de typologie
                if(subpage==='list'){
                    view.navToFlag(currentFlag);
                    view.showTitle(currentFlag);
                    view.reloadList(currentFlag);
                }
            }
        },

        getRenderOptions:function(){
            var view = this,
                filters = app.get('newsFlag').getFilters(),
                currentFlag = view.currentFlag,
                news = app.get('news').filterByFlag(currentFlag);
            pageIndexMax = Math.ceil(news.size()/ITEMS_PER_PAGE);
            return {
                filters:filters,
                currentFlag:currentFlag,
                news:news,
                pageIndex:pageIndex,
                pageIndexMax:pageIndexMax,
                indexMin:(pageIndex-1)*ITEMS_PER_PAGE,
                indexMax:(pageIndex)*ITEMS_PER_PAGE,
            }
        },

        render:function(microtemplating){

            var view = this;
            var options = view.getRenderOptions();

            switch(view.subpage){
                case 'single':
                    view.$el.html(
                        templateSingle(
                            _.extend(options,{
                                singleNews:view.singleNews
                                }
                            )
                        )
                    );
                    //
                    break;
                default:
                case 'list':
                    view.$el.html(templateList(options));
                    break;
            }
            view.initializeLinksOfPage();

        },
        navToFlag:function(currentFlag){
            var view = this, activeClass='active', selector = '.news-filter';
            view.$(selector).removeClass(activeClass);
            view.$(selector+'[data-id="'+currentFlag.id+'"]').addClass(activeClass);
        },
        showTitle:function(currentFlag, news){
            var view = this, visibleClass='visible', selector = '.news-top';
            view.$(selector).removeClass(visibleClass);
            view.$(selector+'[data-id="'+currentFlag.id+'"]').addClass(visibleClass);
        },
        reloadList:function(){
            var view = this;
            view.$('.news-main').html(listTemplate(view.getRenderOptions()));
            view.initializeLinksOfPage();
            app.scrollTop(0,500);
        },
        listIndexPage:function(e){
            preventDefault(e);
            pageIndex = $(e.currentTarget).data('page');
            this.reloadList();
        },
        nextPage:function(e){
            preventDefault(e);
            pageIndex++;
            if(pageIndex>pageIndexMax) pageIndex = 1;
            this.reloadList()
        },
        prevPage:function(e){
            preventDefault(e);
            pageIndex--;
            if(pageIndex<1) pageIndex = pageIndexMax;
            this.reloadList()
        }



        /*
        initialize: function () {
            var self = this;
            ITEMS_PER_PAGE = parseInt(app.c('_NEWS_PAGINATION_',ITEMS_PER_PAGE));
            $('#home-preloader').remove();
            self.listenTo(app, 'change:scrollTop', self.onScroll);
            hash = location.hash.substr(1);
            $newsItems = $('.news-list-item');
            pages = Math.ceil($newsItems.length / ITEMS_PER_PAGE);
            for (var i = pages; i > 0; i--) {
                if (i === 1) {
                    $('.news-list-pagination .icon-arrow-left').after('<span class=\'active\'>' + i + '</span>');
                } else {
                    $('.news-list-pagination .icon-arrow-left').after('<span>' + i + '</span>');
                }
            }
            if (hash) {
                self.clickNavByName();
                return;
            }

            this.paginatedNews();
        },
        filterNav: function (e) {
            $newsItems.show();
            var view = this;
            var button = $(e.currentTarget);
            currentFilter = button.data('filter');
            var selector = '.news-list-item' + (currentFilter === '*' ? '' : '.group-' + currentFilter);

            $('.news-list-item').show();
            $newsItems = $('.news-list-item' + selector);
            pages = Math.ceil($('.news-list-item' + selector).length / ITEMS_PER_PAGE);
            pageIndex = 0;

            $('.news-list-pagination span').not('.arrow').remove();

            for (var i = pages; i > 0; i--) {
                if (i === 1) {
                    $('.news-list-pagination .icon-arrow-left').after('<span class=\'active\'>' + i + '</span>');
                } else {
                    $('.news-list-pagination .icon-arrow-left').after('<span>' + i + '</span>');
                }
            }

            view.$('.news-filter').removeClass('active', false);
            view.$('.news-list-item').not(selector).hide();
            view.$('.news-list-top').removeClass('visible').filter('[data-filter="' + currentFilter + '"]').addClass('visible');
            view.$(selector).show();
            button.addClass('active', true);
            view.onScroll(app);
            this.paginatedNews();
            e.preventDefault();
            e.stopPropagation();
        },
        paginatedNews: function () {
            var start = pageIndex * ITEMS_PER_PAGE;
            var end = start + ITEMS_PER_PAGE;
            $newsItems.slice(start, end).show();
            //$newsItems.slice(start, end).parent().parent().show();
            $newsItems.not($newsItems.slice(start, end)).hide();
            // $('.news-list-pagination span:not(.arrow)').remove();
            // $newsItems.not($newsItems.slice(start, end)).parent().parent().hide();
        },
        nextPage: function () {
            if (pageIndex !== pages - 1) {
                $('.news-list-pagination span').not('.arrow').each(function () {
                    $(this).removeClass('active');
                });
                pageIndex++;
                $('.news-list-pagination span').not('.arrow').eq(pageIndex).addClass('active');
                this.scrollToPosition();
                this.paginatedNews();
            }
        },
        prevPage: function () {
            if (pageIndex !== 0) {
                $('.news-list-pagination span').not('.arrow').each(function () {
                    $(this).removeClass('active');
                });
                pageIndex--;
                $('.news-list-pagination span').not('.arrow').eq(pageIndex).addClass('active');
                this.scrollToPosition();
                this.paginatedNews();
            }
        },
        goToPage: function (e) {
            $('.news-list-pagination span').not('.arrow').each(function () {
                $(this).removeClass('active');
            });
            $(e.currentTarget).addClass('active');
            pageIndex = $(e.currentTarget).text() - 1;
            this.scrollToPosition();
            this.paginatedNews();
        },
        scrollToPosition: function () {
            setTimeout(function () {
                window.scrollTo({
                    top: $('.news-list-nav').offset().top - $('.header-main-wrapper').outerHeight(),
                    behavior: 'smooth'
                });
            }, 100);
        },
        clickNavByName: function () {
            var view = this;

            view.$('.news-filter').each(function (_, filter) {
                if ($(filter).data('filter-name') === hash) {
                    $(filter).click();
                }
            })
        },
        onScroll: function (appModel) {
            var view = this,
                scrollTop = appModel.get('scrollTop'),
                winH = appModel.get('winH');
            view.$('.news-list-content').each(function () {
                var $content = $(this),
                    $item = $content.find('.news-list-col.fixed .news-list-item');

                if (scrollTop < $content.offset().top) {
                    $item.removeClass('floating bottom');
                } else if (scrollTop + $item.height() > $content.offset().top + $content.height()) {
                    $item.removeClass('floating').addClass('bottom');
                } else {
                    $item.removeClass('bottom').addClass('floating');
                }
            })
        }
        */


    });

});
